export const GET_TEST_CATEGORIES = "GET_TEST_CATEGORIES"
export const GET_TEST_CATEGORIES_FAIL = "GET_TEST_CATEGORIES_FAIL"
export const GET_TEST_CATEGORIES_SUCCESS = "GET_TEST_CATEGORIES_SUCCESS"
export const GET_TEST_CATEGORIES_RESET = "GET_TEST_CATEGORIES_RESET"

export const getTestCategories = (params) => {
    return { type: GET_TEST_CATEGORIES, params }
}

export const getTestCategoriesSuccess = (response) => {
    return { type: GET_TEST_CATEGORIES_SUCCESS, response }
}

export const getTestCategoriesFail = (response) => {
    return { type: GET_TEST_CATEGORIES_FAIL, response }
}

export const getTestCategoriesResetState = () => {
    return { type: GET_TEST_CATEGORIES_RESET }
}